export default defineNuxtPlugin((nuxtApp) => {
  const { notifyError, syncUser } = useBugsnagReporter()

  nuxtApp.hook('app:error', (error) => {
    notifyError(error, {
      hook: 'app:error',
    })
  })

  nuxtApp.hook('vue:error', (error, _instance, info) => {
    notifyError(error, {
      hook: 'vue:error',
      info,
    })
  })

  if (!import.meta.client) {
    return
  }

  // Avertissement navigateur bénin (repositionnement des popovers Reka UI), sans impact fonctionnel.
  useBugsnag()?.addOnError((event: any) => {
    const message = event.errors?.[0]?.errorMessage ?? ''
    return !message.includes('ResizeObserver loop')
  })

  const userStore = useUserStore()

  watch(
    () => [
      userStore.isLoggedIn,
      userStore.userId,
      userStore.email,
      userStore.firstName,
      userStore.lastName,
      userStore.fullName,
    ],
    () => {
      syncUser()
    },
    {
      immediate: true,
    },
  )
})
